function addActiveInTableCell(arr = []) {
  return arr.map((item) => ({ ...item, isActive: item?.isActive ?? true }));
}

export default addActiveInTableCell;
